// extracted by mini-css-extract-plugin
export var container = "_6n-0";
export var icon = "_6n-1";
export var text = "_6n-2";